export default __webpack_public_path__ + "static/wedding_background-addfb33addb94111563d0a6aea2dbc60.webp";